


document.addEventListener("DOMContentLoaded", function() {
    let listItems = document.querySelectorAll(".hon-header__accordian");
    
    listItems.forEach((listItem, index) => {
        listItem.addEventListener("click", function() {
            let listContainer = document.getElementsByClassName("hon-menu-drawer__list-menu")[index];
            let categoryList = document.getElementsByClassName("hon-header__product-category")[index];
            
            document.querySelectorAll(".hon-menu-drawer__list-menu").forEach((container, i) => {
                if (i !== index) {
                    container.style.display = "none";
                }
            });
            document.querySelectorAll(".hon-header__product-category").forEach((category, i) => {
                if (i !== index) {
                    category.style.display = "none";
                }
            });
            
            if (listContainer.style.display === "block") {
                listContainer.style.display = "none";
                categoryList.style.display = "none";
            } else {
                listContainer.style.display = "block";
                categoryList.style.display = "block";
            }
            
        });
    });
});

